import { render, staticRenderFns } from "./update-base.vue?vue&type=template&id=67600359&"
import script from "./update-base.vue?vue&type=script&lang=js&"
export * from "./update-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports